export type IssueKeysDraft = {
  count: number;
  reason: string;
};

export type DeviceLimitHandoff = {
  kind: "increase-device-limit";
  licenseId: string;
  returnTo: string;
  suggestedLimit: number;
  draft: IssueKeysDraft;
};

export type IssueKeysRestore = {
  kind: "restore-issue-keys";
  licenseId: string;
  draft: IssueKeysDraft;
};

export function readDeviceLimitHandoff(
  state: unknown,
  licenseId: string,
): DeviceLimitHandoff | null {
  if (!state || typeof state !== "object") return null;
  const candidate = state as Partial<DeviceLimitHandoff>;
  if (
    candidate.kind !== "increase-device-limit" ||
    candidate.licenseId !== licenseId ||
    typeof candidate.returnTo !== "string" ||
    !/^\/admin\/licenses(?:\/|\?|$)/.test(candidate.returnTo) ||
    !Number.isSafeInteger(candidate.suggestedLimit) ||
    (candidate.suggestedLimit ?? 0) < 1 ||
    !validDraft(candidate.draft)
  ) return null;
  return candidate as DeviceLimitHandoff;
}

export function readIssueKeysRestore(
  state: unknown,
  licenseId: string,
): IssueKeysRestore | null {
  if (!state || typeof state !== "object") return null;
  const candidate = state as Partial<IssueKeysRestore>;
  if (
    candidate.kind !== "restore-issue-keys" ||
    candidate.licenseId !== licenseId ||
    !validDraft(candidate.draft)
  ) return null;
  return candidate as IssueKeysRestore;
}

function validDraft(draft: unknown): draft is IssueKeysDraft {
  if (!draft || typeof draft !== "object") return false;
  const candidate = draft as Partial<IssueKeysDraft>;
  return Number.isInteger(candidate.count) &&
    (candidate.count ?? 0) >= 1 &&
    (candidate.count ?? 0) <= 1_000 &&
    typeof candidate.reason === "string" &&
    candidate.reason.trim().length > 0;
}
